import {BaseTerms} from "../../infrastructure/models/base-terms";

export class MyScoresWidgetTerms extends BaseTerms {
  WEB_MY_SCORES_RECENTLY_ENDED = "Recently Ended";
  WEB_MY_SCORES_LAST_NIGHT = "Last Night";
  WEB_MY_SCORES_TODAYS_MATCHES = "Today's Matches";
  WEB_MY_SELECTIONS_EMPTY_STATE_TODAY = "No followed games today";
  WEB_MY_SCORES_DATE_SINGLE_GAME = "1 Match";
  WEB_MY_SCORES_DATE_TWO_GAMES = "#NUM Matches";
  WEB_MY_SCORES_DATE_GAMES = "#NUM Matches";
  WEB_MY_SCORES_DATE_ELEVEN_GAMES = "#NUM Matches";
  WEB_MY_SCORES_PAGE_EMPTY_STATE_TODAY = "No followed games today, nor any of your followed teams are playing";
  WEB_MY_SCORES_NO_LIVE_MATCHES = "Currently No Live Games";
  WEB_MY_SCORES_SEE_ALL_LIVE_MATCHES = "See all Live Games";
  WEB_MY_SCORES_COMPETITIONS_SEPARATOR = "My Competitions";
  WEB_MY_SCORES_PAGE_EMPTY_STATE_RELEVANT_DATES = 'No relevant games on these dates';
  WEB_SUGGESTED_GAMES = 'Suggested Games';
}
